// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"399":"309e4b6c","540":"adaa1006","732":"485f9f7b","977":"9f28888c"}[chunkId] + ".chunk.js";
};